import { InternalAxiosRequestConfig } from "axios";

import i18n from "../../i18n";

export const attachAcceptLanguage = (config: InternalAxiosRequestConfig) => {
  config.headers["accept-language"] = i18n.language || "en";

  return config;
};
